import React from 'react';
import { useTranslation } from 'react-i18next';
import MyPath2ASULogo from '../../ASUPhotos/logos/MyPath2ASU_Arrow.png';
import MyPath2ASUHero from '../../ASUPhotos/MyPath2ASU_Hero.png';

const myPathAsuTM = 'MyPath2ASU™';

export const MyPath2ASU = (props) => {
  const secondaryColorBar = {
    height: '3px',
    width: '62px',
    backgroundColor: `${props.tenant.secondary}`,
  };

  const primaryLink = {
    color: `${props.tenant.primary}`,
    fontSize: '14px',
    fontWeight: 'bold',
    textDecoration: 'underline',
    cursor: 'pointer',
  };

  const { t } = useTranslation();

  return (
    <div className="my-path-2-asu">
      <img
        src={MyPath2ASUHero}
        className="my-path-2-asu__hero"
        alt={t('A group of students walking outside')}
      />
      <div className="my-path-2-asu__content-container">
        <div className="my-path-2-asu__header-container">
          <p className="my-path-2-asu__header">{myPathAsuTM}</p>
          <img
            src={MyPath2ASULogo}
            className="my-path-2-asu__logo"
            alt={t('{{brandname}} logo', { brandname: 'My Path to ASU' })}
          />
        </div>
        <div style={secondaryColorBar} />
        <div className="my-path-2-asu__description-container">
          <p className="my-path-2-asu__description">
            {t(
              'Looking to transfer to ASU? Use the {{brandname}} tool to learn more about ASU’s majors and how your transfer courses could fulfill requirements. You can also use this tool to determine the ASU equivalencies to your individual transfer coursework.',
              { brandname: myPathAsuTM }
            )}
          </p>
          <a
            href="https://webapp4.asu.edu/transfercreditguide/app/transfermap?_ga=2.187702379.2116459387.1643663311-86504102.1643663311"
            className="my-path-2-asu__cta"
            style={primaryLink}
            target="_blank"
            rel="noreferrer noopener"
          >
            {t('Explore {{websiteName}}', { websiteName: myPathAsuTM })}
          </a>
        </div>
      </div>
    </div>
  );
};
